import React from "react";

const Stat_Standard_Deviation = () => {
  return (
    <div>
      <h1>Stat Standard Deviation</h1>
    </div>
  );
};

export default Stat_Standard_Deviation;
